import StyleSheet from 'react-native-extended-stylesheet';

export const style = StyleSheet.create({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: '$colorBgBase',
    height: 48, // avoid using token because of tiny theme
    justifyContent: 'space-between',
  },
  menu: {
    justifyContent: 'center',
    marginRight: '$space2',
    marginLeft: 'auto',
    padding: '$space2',
  },
});
